import { CategoryEnum } from 'app/policies/policy.enums';

export enum UsersSettingConstant {
  firstParty = 'first-party',
  upperdeck = 'upperdeck',
  default = 'default',
  custom = 'custom',
  thirdParty = 'third-party',
  boardView = 'board',
  defaultSetting = 'default settings',
  overView = 'overview',
  wizard = 'wizard',
  vendors = 'vendors',
  customVendors = 'custom-vendors',
  name = 'name',
  ascending = 'asc',
  userSettings = 'Settings',
  clients = 'clients',
  profit_center = 'Profit Center',
}

export enum UsersSettingScreens {
  users = 'users',
  permissions = 'permissions',
}
export enum FirstPartyTabs {
  COLLECTION = 'collection',
  UPPERDECK = 'upper deck',
  PILLARS = 'pillars',
  BREAK_DOWN = 'break down',
  MULTI_ENTITY = 'multi entity',
  REMEDIATION_CENTER = 'remediation center',
  USER_sETTINGS = 'user settings',
  RISK_REGISTER = 'risk register',
  INTEGRATIONS = 'integrations',
}

export const CATEGORY_GROUPS = [
  {
    name: 'Custom',
    color: '#F8A12A',
    items: [],
  },
  {
    name: 'Security',
    color: '#29a9eb',
    items: [
      CategoryEnum.InformationSecurityPolicy,
      CategoryEnum.AccessPolicy,
      CategoryEnum.AssetManagement,
      CategoryEnum.DeviceUsagePolicy,
      CategoryEnum.PhysicalSecurity,
    ],
  },
  {
    name: 'Privacy',
    color: '#a259e6',
    items: [CategoryEnum.PrivacyPolicy, CategoryEnum.DPOStatement, CategoryEnum.DataCategory],
  },
  {
    name: 'Regulation',
    color: '#e659a2',
    items: [CategoryEnum.EnvironmentalPolicy, CategoryEnum.PaperPolicy],
  },
  {
    name: 'Organizational Policy',
    color: '#3ec46d',
    items: [
      CategoryEnum.BusinessContinuity,
      CategoryEnum.DisasterRecovery,
      CategoryEnum.Insurance,
      CategoryEnum.HiringEmployees,
      CategoryEnum.EmployeeTermination,
      CategoryEnum.IncidentResponse,
    ],
  },
];
